import { Button } from "@/components/ui/button";
import { LogicalConditionRow } from "./LogicalConditionRow";
import { ConditionRow } from "./ConditionRow";

interface BuilderProps {
    condition?: Condition;
    onChange: (c?: Condition) => void;
    questions: Record<string, PolicyFormQuestion>;
}

export const Builder: React.FC<BuilderProps> = ({ condition, onChange, questions }) => {
    if (!condition) {
        return (
            <Button size="sm" variant="outline" onClick={() => onChange({ field: "", operator: "equals", value: "" })}>
                + Add condition
            </Button>
        );
    }

    if ('operator' in condition) {
        return (
            <LogicalConditionRow
                condition={condition as LogicalCondition}
                onChange={onChange}
                onDelete={() => onChange(undefined)}
                questions={questions}
            />
        );
    }

    return (
        <ConditionRow
            condition={condition as FieldCondition}
            onChange={onChange}
            onDelete={() => onChange(undefined)}
            questions={questions}
        />
    );
};